/**
 * The outgoing-mail log (`mail_log`, from @speles7172/message-client) as the
 * application's Mail log screens read it: every email and text sent, what
 * became of it, and the addresses no longer mailed.
 */
export const MAIL_LOG_CHANNELS = ['email', 'sms'];
/**
 * Whether the send was made. `simulated`: outside production nothing leaves;
 * `suppressed`: every address had bounced or complained before.
 */
export const MAIL_LOG_STATUSES = ['queued', 'sent', 'simulated', 'suppressed', 'failed'];
/** What the provider reported afterwards. Separate from whether it was sent. */
export const MAIL_LOG_DELIVERIES = ['delivered', 'bounced', 'complained'];
export const MAIL_SUPPRESSION_REASONS = ['bounce', 'complaint', 'manual'];
//# sourceMappingURL=mail-log.js.map